<template>
<div class="container">
  <div class="section">
    <div class="columns">  
      <div class="column is-8 has-text-centered">
        <h1 class="title is-1">Congratulations {{players[0].data.nickName}}!</h1>
        <span class="icon is-large space-top">
          <i class="fas fa-medal fa-5x has-text-yellow"></i>
        </span>
        <div class="buttons is-centered section">
          <button @click="goHome" class="button is-primary is-large">
            <span class="icon">
              <i class="fas fa-home"></i>
            </span>
            <span>
              Go Home
            </span>
          </button>
        </div>
      </div>
      <div class="column is-4">
        <div class="scores-holder">
          <h1 class="title is-4">Scores</h1>
          <table class="table">
            <thead>
              <tr>
                <th>Player</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in players" :key="p.id">
                <td>{{p.data.nickName}}</td>
                <td>{{p.data.score}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ub-game-result',
  props: [],
  data() {
    return {
    };
  },
  computed: {
    players() {
      const players = this.$store.getters['trivia/players'];
      return players.sort((a, b) => b.data.score - a.data.score);
    },
  },
  methods: {
    goHome() {
      this.$router.push({
        name: 'ub-home',
      });
    }
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.scores-holder{
  border-right: 1px solid #ddd;
}
</style>
